import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Tracking from '../lib/fpti';
import * as TrackingActions from '../actions/tracking';
import * as AppActions from '../actions/app';
import ErrorPanel from '../components/Error';
import AppError from '../components/AppError';
import ErrorBoundary from '../lib/ErrorBoundary';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { RouteWithSubRoutes } from '../../routes/routeHelpers';
import { get } from 'lodash';
import Loader from 'kepler/lib/components/Loader';

class App extends React.Component {
  render() {
    const { routes } = this.props;
    // redirect if user is hitting /merchantapps/ route without a child route
    if (
      typeof window !== 'undefined' &&
      !window.location.pathname.split('/merchantapps/').filter(a => a.length)
        .length
    ) {
      window.location.assign('/merchantapps/myapps');
    }

    const { app, children } = this.props,
      { isMpp, type } = app,
      isLoading = get(app, 'loading', false);

    let merchantHeader = false,
      merchantFooter = false;

    if (!isMpp && type === 'BUSINESS' && typeof window !== 'undefined') {
      merchantHeader = <header className="merchant-header"></header>;
      merchantFooter = <footer className="merchant-footer"></footer>;
    }

    return (
      <Fragment>
        {(() => (
          <div id="merchanthub-content">
            <ErrorBoundary>
              {merchantHeader}
              {app.error ? <ErrorPanel {...this.props} /> : children}
              <Loader
                key="loading"
                show={isLoading}
                type="fixed"
                priority={10}
              />
              {app.serverError &&
              !this.props.location.pathname.includes('/error') ? (
                <AppError {...this.props} />
              ) : (
                <Switch>
                  {routes &&
                    routes.map((route, i) => (
                      <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch>
              )}
              {merchantFooter}
            </ErrorBoundary>
          </div>
        ))()}
      </Fragment>
    );
  }
}

App.propTypes = {
  app: PropTypes.object,
  dispatch: PropTypes.func,
  children: PropTypes.node,
  tracking: PropTypes.object,
  recordClick: PropTypes.func,
  recordImpression: PropTypes.func,
  flows: PropTypes.object,
  loading: PropTypes.bool,
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    app: get(state, 'app', {}),
    tracking: Tracking,
    metadata: get(state, 'metadata', {}),
    user: get(state, 'user', {}),
    experimentation: get(state, 'experimentation', {}),
    surveyInput: get(state, 'myapps.surveyInput', {}),
    surveySubmitted: get(state, 'myapps.surveySubmitted', false),
    surveyError: get(state, 'myapps.surveyError', false)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...TrackingActions,
    ...AppActions,
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
